/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { WarningIcon } from 'foundations-assets/icons/components/WarningIcon';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useSendEmailBreakdown, useMostRecentExamAttempt } from '../../exams/examsQueries';
import { useUserInfo } from '../../accounts';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmailBreakdownButton = ({
  language,
  marginBlockStart,
  paddingBlock,
  tooltipTitle,
  trackId
}) => {
  const {
    userInfo
  } = useUserInfo();
  const [feedbackMessage, setfeedbackMessage] = useState(false);
  const {
    mostRecentExamAttempt
  } = useMostRecentExamAttempt(Number(trackId), language);
  const [sendEmailBreakdown, {
    sendEmailBreakdownLoading,
    sendEmailBreakdownError
  }] = useSendEmailBreakdown();
  const getUpdatedMessage = () => feedbackMessage ? 'learningCenter.exams.finished.checkYourEmail' : 'learningCenter.exams.finished.sendBreakdownWait';
  return sendEmailBreakdownLoading ? /*#__PURE__*/_jsx(LoadingSpinner, {
    grow: true,
    inlineSize: "250px"
  }) : /*#__PURE__*/_jsx(Tooltip, {
    "data-test-id": "email-exam-breakdown-button-tooltip",
    title: mostRecentExamAttempt && mostRecentExamAttempt.finished ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: getUpdatedMessage(),
      options: {
        emailAddress: userInfo && userInfo.user.emails[0]
      }
    }) : tooltipTitle,
    children: /*#__PURE__*/_jsx(Text, {
      marginBlockStart: marginBlockStart,
      paddingBlock: paddingBlock,
      paddingInline: "500",
      textAlign: "center",
      children: /*#__PURE__*/_jsxs(Link, {
        "data-test-id": "email-exam-breakdown-button",
        disabled: !!mostRecentExamAttempt && !mostRecentExamAttempt.finished,
        onClick: () => {
          if (!mostRecentExamAttempt) {
            return null;
          }
          return sendEmailBreakdown(mostRecentExamAttempt.id, Number(trackId), mostRecentExamAttempt.language).then(() => setfeedbackMessage(true));
        },
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.exams.finished.emailExamBreakdown"
        }), !!sendEmailBreakdownError && /*#__PURE__*/_jsx(IconHolder, {
          icon: WarningIcon
        })]
      })
    })
  });
};
export default EmailBreakdownButton;